
export function getLatitude(location?: TLocation): number | undefined {
    if (!location) return undefined;
    if (location.location_source === "map") return location.map_location?.coordinates[1];
    if (location.latitude) return Number(parseFloat(location.latitude));
    return undefined;
}

export function getLongitude(location?: TLocation): number | undefined {
    if (!location) return undefined;
    if (location.location_source === "map") return location.map_location?.coordinates[0];
    if (location.longitude) return Number(parseFloat(location.longitude));
    return undefined;
}